
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { ThemeClasses } from "./CraftGeneratorTheme";

interface AddCustomSupplyProps {
  onAddSupply: (name: string) => void;
  themeClasses: ThemeClasses;
}

const AddCustomSupply: React.FC<AddCustomSupplyProps> = ({ 
  onAddSupply, 
  themeClasses 
}) => {
  const [customSupply, setCustomSupply] = useState("");

  const handleAddSupply = () => {
    if (customSupply.trim() !== "") {
      onAddSupply(customSupply);
      setCustomSupply("");
    }
  };

  return (
    <div className="flex items-end gap-2">
      <div className="flex-1">
        <Label htmlFor="custom-supply">Add Your Own Supply:</Label>
        <Input
          id="custom-supply"
          value={customSupply}
          onChange={(e) => setCustomSupply(e.target.value)}
          placeholder="e.g., Pine Cones"
          className="mt-1"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddSupply();
            }
          }}
        />
      </div>
      <Button 
        onClick={handleAddSupply}
        className={themeClasses.addClass}
        disabled={customSupply.trim() === ""}
      >
        <Plus className="mr-2 h-4 w-4" /> Add
      </Button>
    </div>
  );
};

export default AddCustomSupply;
